module.exports = __webpack_public_path__ + "static/img/227_1920_572.9055ead.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/227_1920_572.jpg
// module id = OkTO
// module chunks = 0